
import "/home/dispatchbutler/data/dispatchbutler/frontend/src/components/RightContent/index.less?modules";
export default {"account": `account-9eYpYg8X`,"search": `search-FnelDlhx`,"avatar": `avatar-fNJ7paEM`,"dark": `dark-l1oe1Sds`,"menu": `menu-zqJ-3VNQ`,"right": `right-wrhZnPjr`,"action": `action-aI9m09ox`,"name": `name-sZeDv6qe`}
